import { render } from "./ResumeAcceptInfo.vue?vue&type=template&id=976de6b8&scoped=true"
import script from "./ResumeAcceptInfo.vue?vue&type=script&lang=js"
export * from "./ResumeAcceptInfo.vue?vue&type=script&lang=js"

import "./ResumeAcceptInfo.vue?vue&type=style&index=0&id=976de6b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-976de6b8"]])

export default __exports__